export default function sectionBlock(name) {
  return { content_section: name };
}
